var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink, Download01Icon, Trans } from '@lucidlink/uicore';
import { DESKTOP_APPLICATION_DOWNLOAD_URL } from '@lucidlink/workspacemanagement';
export const UploadYourFirstFilesAction = () => {
    return (_jsx(ButtonLink, { "data-testid": "download-app-onboarding", kind: "secondary", StartIcon: Download01Icon, to: DESKTOP_APPLICATION_DOWNLOAD_URL, children: _jsx(Trans, { children: "Download app" }) }));
};
_react_refresh_temp_1 = UploadYourFirstFilesAction;
$RefreshReg$(_react_refresh_temp_1, "UploadYourFirstFilesAction");
